import React from 'react';
import { useTranslation } from 'react-i18next';

const BuildInfoCard: React.FC = () => {
  const { t } = useTranslation('webflash');

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('firmware.buildInfo')}
      </h3>
      <p className="text-sm text-gray-400">{t('firmware.noVersions')}</p>
    </div>
  );
};

export default BuildInfoCard;
